module.exports = __webpack_public_path__ + "img/Linguetta_DX.a69be022.png";